import React from "react";

const ResultEmpty = () => (
    <div className="savings-calculator__result savings-calculator__result--empty">
        <p className="savings-calculator__result-eyebrow">Ahorro anual estimado</p>
        <p className="savings-calculator__result-figure">0</p>
        <p className="savings-calculator__result-note">
            *Estimado bajo condiciones de manejo eficiente
        </p>
    </div>
);

export default ResultEmpty;
